/**
 * Created by intellicar-rinas on 4/10/17.
 */
import {
    schemaTypes,
    dateFormat,
    fuelTypeMap,
    simpleTimeFormat
  } from "../../../constants/constants";
  import ReportAPIs from "../../../APIs/ReportAPIs";
  import GeoCodeAPIs from "../../../APIs/GeoCodeAPIs";
  import { JSONToCSVConvertor, stripLoc } from "../../../helpers/helperFunctions";
  import {
    flipRange,
    canShowRangeSwitch,
    onFetchOdo,
    changeVehicle,
  } from "./historyReport/historyReport";
  import moment, { max } from "moment";
  import _ from "lodash";
  import { changeToHours } from "../reports/dailyReport";
  import humanizeDuration from "humanize-duration";
  // import mixpanel from "mixpanel-browser";
  import actions from '../../../store/actions';
  import { isEvGroup } from "../reports/summaryReport";
  
  const shortEnglishHumanizer = humanizeDuration.humanizer({
    language: "shortEn",
    languages: {
      shortEn: {
        y: () => "y",
        mo: () => "mo",
        w: () => "w",
        d: () => "d",
        h: () => "h",
        m: () => "m",
        s: () => "s",
        ms: () => "ms",
      },
    },
  });
  
  const preProcessData = (respObj) => {
    let oldrespObj = {};
    for (let idx in respObj) {
      let item = respObj[idx];
      if (!(item.vehicleid in oldrespObj)) {
        oldrespObj[item.vehicleid] = [];
      }
      oldrespObj[item.vehicleid].push(item);
    }
  
    return oldrespObj;
  };
  
  export const getFuelPrices = (historyData, callback) => {
    let data = []
    for (let idx in historyData){
      let time = moment(historyData[idx].starttime).startOf("day").valueOf() + 19800000;
      let location = ((historyData[idx].startloc || "").split("("));
      location =( _.last((location[0] || "").split(","))).trim();
      location = location.toLowerCase().replace(/\s/g, "-");
  
      let fueltype = fuelTypeMap[historyData[idx].fueltype];
      data.push([time,location,fueltype])
    }
    function cphFunc(cost, duration) {
      return (cost / Math.max(1, duration)).toFixed(2);
    }
    ReportAPIs.getFuelPrice({ data }).then((rsp) => {
      //  console.log("fuel resp",rsp)
      for (let idx in historyData) {
        let fuelprice = rsp[idx][3];
        let fuelused = historyData[idx].fuelused || 0;
        let { distance, hrs } = historyData[idx];
        let cpk = distance ? ((fuelused * fuelprice) / distance).toFixed(2) : 0;
        if (window.userInfo.SELF.pbl_report === "SHOW") {
          let cph = cphFunc(fuelused * fuelprice, hrs / 60);
          historyData[idx].cph = cph;
        }
        if(historyData[idx].cpk === null) historyData[idx].cpk = cpk;
        if(historyData[idx].fuelprice === null)historyData[idx].fuelprice = (fuelprice * fuelused).toFixed(2);
      }
      callback(historyData);
    });
  };
  
  export const processData = (respObj, vehicleMap, callback, noFilter) => {
    let historyData = [];
    let locationbodyfrom = [];
    let locationbodyto = [];
  
    for (let vehiclepath in respObj) {
      let vehicleno = vehicleMap[vehiclepath].vehicleno;
      let fueltype = _.get(vehicleMap, vehiclepath + ".vehiclemeta.fueltype");
      let model = vehicleMap[vehiclepath].vehicleModel
        ? vehicleMap[vehiclepath].vehicleModel.model
        : vehicleMap[vehiclepath].vehiclemeta
        ? vehicleMap[vehiclepath].vehiclemeta.model || ""
        : "";
  
      let source = vehicleMap[vehiclepath].vehiclemeta && vehicleMap[vehiclepath].vehiclemeta.variant &&
        vehicleMap[vehiclepath].vehiclemeta.variant === "API" ? "API" : "Intellicar"
      // console.log(vehicleMap[vehiclepath].vehiclemeta.variant) 
      for (let ridx in respObj[vehiclepath]) {
        let eachitem = respObj[vehiclepath][ridx];
        let group1 =eachitem.groups[0]? eachitem.groups[0]:''
        let group2 =eachitem.groups[1]? eachitem.groups[1]:''
        let group3 =eachitem.groups[2]? eachitem.groups[2]:''
        let group4 =eachitem.groups[3]? eachitem.groups[3]:''
        let starttime =
          eachitem.starttime != null ? moment(eachitem.starttime).format(dateFormat) : null;
        let endtime =
          eachitem.endtime != null ? moment(eachitem.endtime).format(dateFormat) : null;
        let duration =
          eachitem.tripduration != null
            ? parseFloat(eachitem.tripduration.toFixed(2))
            : null;
        let distance =
          eachitem.tripdistance != null
            ? parseFloat(eachitem.tripdistance.toFixed(2))
            : null;
        let fuelused =
          eachitem.fuelused != null && distance != null
            ? parseFloat(eachitem.fuelused.toFixed(2))
            : null;
        let mileage1 =
          eachitem.mileage ? (eachitem.mileage.toFixed(2)) : fuelused != null && fuelused > 0 && distance != null
            ? parseFloat(distance / fuelused).toFixed(2)
            : 0;
        let avgspeed = eachitem.avgspeed || 0;
        let tDuration = shortEnglishHumanizer(eachitem.duration, { largest:2 }) 
        let status = eachitem.status
        let startodo =
          eachitem.startodo != null
            ? parseFloat(eachitem.startodo.toFixed(0))
            : null;
        let endodo =
          eachitem.endodo != null ? parseFloat(eachitem.endodo.toFixed(0)) : null;
        let tripscore = eachitem.tripscore;
        // let startloc = eachitem.saddress;
        let startloc = '(' + String(eachitem.lat) + ',' + String(eachitem.lng) + ')';
        // let endloc = eachitem.eaddress;
        let endloc = '(' + String(eachitem.late) + ',' + String(eachitem.lnge) + ')'
        let idlingtime =
          eachitem.idlingtime != null
            ? parseFloat(
                (eachitem.idlingtime > 0
                  ? eachitem.idlingtime / 1000 / 60
                  : 0
                ).toFixed(2)
              )
            : null;
        let acidlingtime =
          eachitem.acidlingtime != null
            ? parseFloat(
                (eachitem.acidlingtime > 0
                  ? eachitem.acidlingtime / 1000 / 60
                  : 0
                ).toFixed(2)
              )
            : null;
        let EndLatLng = [eachitem.late, eachitem.lnge];
        let StartLatLng = [eachitem.lat, eachitem.lng];
        let startfl = eachitem.startfl;
        let endfl = eachitem.endfl;
        let startdte = eachitem.startdte;
        let enddte = eachitem.enddte;
        let cpk = eachitem.cpk ? eachitem.cpk.toFixed(2) : null;
        let fuelprice = eachitem.fuelprice ? eachitem.fuelprice.toFixed(2) : null;
        locationbodyfrom.push([eachitem.lat, eachitem.lng]);
        locationbodyto.push([eachitem.late, eachitem.lnge]);
        if (window.userInfo.SELF.pbl_report === "SHOW") {
          let hrs = eachitem.tripduration;
          let ophours = changeToHours(hrs);
          let consumption = (fuelused / Math.max(1, hrs / 60)).toFixed(2);
          historyData.push({
            group1,
            group2,
            group3,
            group4,
            vehicleno,
            model,
            starttime,
            endtime,
            tDuration,
            duration,
            distance,
            fuelused,
            mileage1,
            avgspeed,
            idlingtime,
            acidlingtime,
            startodo,
            endodo,
            tripscore,
            fueltype,
            startfl,
            endfl,
            StartLatLng,
            EndLatLng,
            startloc,
            endloc,
            startdte,
            enddte,
            hrs,
            ophours,
            consumption,
            status,
            cpk,
            fuelprice
          });
        } else {
          historyData.push({
            group1,
            group2,
            group3,
            group4,
            vehicleno,
            model,
            starttime,
            endtime,
            tDuration,
            duration,
            distance,
            fuelused,
            mileage1,
            avgspeed,
            idlingtime,
            acidlingtime,
            startodo,
            endodo,
            tripscore,
            fueltype,
            startfl,
            endfl,
            StartLatLng,
            EndLatLng,
            startloc,
            endloc,
            startdte,
            enddte,
            status,
            cpk,
            fuelprice,
            source,
          });
        }
      }
    }
  
    callback(historyData);
    if (historyData.length) getFuelPrices( historyData, callback);
    if(noFilter)filterAndSetData1()
    GeoCodeAPIs.getAddress(locationbodyfrom).then(
      (resp) => {
        // console.log(resp)
  
        for (let idx in historyData) {
          historyData[idx].startloc =
            (resp[idx] ? resp[idx][1] : "") +
            " (" +
            historyData[idx].startloc +
            ")";
        }
        callback(historyData);
        if (historyData.length) getFuelPrices(historyData, callback);
      },
      (resp) => {
        console.log(resp);
      }
    );
    GeoCodeAPIs.getAddress(locationbodyto).then(
      (resp) => {
        for (let idx in historyData) {
          historyData[idx].endloc =
            (resp[idx] ? resp[idx][1] : "") +
            " (" +
            historyData[idx].endloc +
            ")";
        }
        callback(historyData);
      },
      (resp) => {
        console.log(resp);
      }
    );
  };
  
  export const filterAndSetData1 = () => {
    // const schema = this.schema;
    let data = schema.content[0].ref.state.currentPage;
    let selectedItems = schema.toolbar[4].ref.getData();
    if (selectedItems) {  
      data = data.filter((i) => {
        let matched;
        for (let idx in selectedItems) {
          if(selectedItems[idx].name === "All" && selectedItems[idx].data.state === true){
            matched = true
            break
          }
          if (
            i.status &&
            i.status.indexOf(selectedItems[idx].name) !== -1
          ) {
            matched = true;
            break;
          }
        }
        return matched;
      });
      window.downloadTripData = data
      if (schema.content[0].ref) {
        schema.content[0].ref.setData(data,false, "edaa monee");
      }
    }
  };
  
  const setStatusTypes = (widget, status) => {
    let data = [];
    let counter = 0;
    for (let idx in status) {
      // if (status[idx]) {
        counter++;
        data.push({
          name: idx,
          id: counter,
          state: status[idx]
        });
      // }
    }
    widget.setData({ dataid: Date.now(), data, name: "name", id: "id" }, true);
    widget.setItemByIds(
      data.map((i) => {
        return i.id;
      })
    );
    widget.setInputValue("");
  };
  
  const getHistory = (schema, data, store) => {
    window.getButtonClicked = true;
    window.resetIndex()
    schema.showPage = true
    // this.finalData = null;
    let saveState = null;
    let tableStateData = null;
    let starttime = data.starttime.unix() * 1000;
    let endtime = data.endtime.unix() * 1000;
    let vehicleDataForReport = {}
    let fixedQueryLimit = 700;
    let splitedVehicles = []
    let vehicleids = []
    data.vehicle = window.selectedItems && window.selectedItems.length ? window.selectedItems : window.itemClicked ? window.selectedVehicles : window.selectedVehicles && window.selectedVehicles.length ? window.selectedVehicles : []
    // data.vehicle =  window.selectedVehicles ? window.selectedVehicles : []
    if(!data.vehicle.length ){
      store.dispatch({
        type: "ADD_INTOAST",
        data: {
          name: "Please select a vehicle",
          content: "Please select a vehicle",
          createAt: Date.now(),
          autoClose: 8000,
          showError:true
        },
      });
      return;
    }
    if(endtime - starttime > 1000 * 60 * 60 * 24 * 35) {
      store.dispatch({
        type: "ADD_INTOAST",
        data: {
          name: "You can't select a date range of more than 35 days",
          content: "You can't select date range of more than 35 days",
          createAt: Date.now(),
          autoClose: 8000,
          showError:true
        },
      });
      return;
    }
    if(starttime >= endtime){
      store.dispatch({
        type: "ADD_INTOAST",
        data: {
          name: "Start time should be less than the end time",
          content: "Start time should be less than the end time",
          createAt: Date.now(),
          autoClose: 8000,
          showError:true
        },
      });
      return;
    }
    // if(starttime === endtime){
    //   endtime = endtime + (1000 * 60 * 60 * 24 - 60000)
    // }
    // let tempEndtime = endtime
    // let value=moment(tempEndtime).startOf('day')
    // tempEndtime = (value).unix() * 1000;
    // let a = (1000 * 60 * 60 * 24) - 60000
    // let diff = endtime - tempEndtime
    // if(diff === a ){
    //   endtime = endtime + 60000
    // }
    let days = (endtime - starttime)
    schema.count = 0
    days =Math.ceil( days / 86400000) //total days
    let queryLimit = data.vehicle.length * days * 10// total query limit
    schema.count = Math.ceil(queryLimit / fixedQueryLimit) // page number
    schema.splitCount = parseInt(data.vehicle.length / schema.count) // total vehicle / total pages
    if(schema.splitCount > 50) schema.splitCount = 50
  
    let getReportBody = {
      starttime: starttime,
      endtime: endtime,
    }
    if( !window.selectAllClicked){ 
      // if(data.vehicle.length <=50){
        getReportBody.vehicle = data.vehicle.map((item) => {
        return item.data.vehicleid;
        })
    }
    // console.log(schema)
    if (window.setReportWindowTabBusy)
          window.setReportWindowTabBusy(schema, true);
    ReportAPIs.getReportVehicles(getReportBody).then ((resp) => {
      vehicleids = resp
      let startIndex = 0
      let endIndex = schema.splitCount;
      for(let pages = 0 ; pages < schema.count; pages++){
        let page = []
        for(let idx in vehicleids){
          if(idx >= startIndex && idx <= vehicleids.length ){
            if(idx <= endIndex - 1)page.push(vehicleids[idx])
          }
        }
        splitedVehicles.push(page)
        startIndex = endIndex;
        endIndex = startIndex + schema.splitCount
        if(pages === (schema.count - 1) && startIndex <= vehicleids.length){
          if((vehicleids.length - startIndex) > 0){
            schema.count++
          }
        }
      }
      if (data.vehicle && data.vehicle.length) {
        // if (window.setReportWindowTabBusy)
          window.setReportWindowTabBusy(schema, true);
        const handleSuccess = (resp) => {
          window.dataForAll = resp;
          if (window.setReportWindowTabBusy)
            window.setReportWindowTabBusy(schema, false);
          let oldrespObj = preProcessData(resp);
          let noFilter = true
          processData(oldrespObj, store.vehicleMap,  (data) => {
            // console.log("Processed mileage data:", data);
            // this.finalData = data;
            vehicleDataForReport =  {
              endtime : endtime,
              starttime : starttime,
              mileageVehicles : splitedVehicles,
              reportName : schema.key,
              mileageFirstData: data,
              selectedVehicles : data.vehicle,
              mileagePageno: schema.count,
              showPage: schema.showPage,
            //   selectedTripVehicles :data.vehicle
            selectedMileageVehicles :data.vehicle
            }
            store.dispatch({
              type: actions.SELECTED_VEHICLE_ID,
              data: vehicleDataForReport
            });
            if (tableStateData && tableStateData[0]) {
              tableStateData[0].body = data;
              tableStateData[0].busy = false;
              saveState(tableStateData[0], tableStateData[1], tableStateData[2]);
            }
            let status = {"All" :true,"Moving":false, "Idle":false,"Ig off":false}
            setStatusTypes(schema.toolbar[4].ref, status);
            if (schema.content[0].ref) {
              schema.content[0].ref.setData(data);
            }
            filterAndSetData1();
          },noFilter);
        };
      
  
        if (schema.content[0].ref) {
          schema.content[0].ref.setBusy(true);
          saveState = schema.content[0].ref.props.saveState;
          tableStateData = [
            schema.content[0].ref.state,
            schema.content[0].ref.props.schemaKey,
            schema.content[0].ref.props.data,
          ];
        }
        let body = {
          // vehicleid: data.vehicle.map((item) => {
          //   return item.data.vehicleid;
          // }),
          vehicleid : splitedVehicles[0],
          starttime: starttime,
          endtime: endtime
        };
        if(window.showNoGpsFixData === true){
          body.fixqfilter = false
        }
        ReportAPIs.getPrecomputeTrips(body).then(handleSuccess, (r) => {
          handleSuccess({});
        });
      } else {
        window.graphDataErr = "";
  
        window.dataForAll = null;
        window.graphDataErr = "Please Select Vehicle";
  
        if (window.InMapForceUpdate) {
          window.InMapForceUpdate();
        }
        if (window.InGraphControlForceUpdate) {
          window.InGraphControlForceUpdate();
        }
        // window.dispatchStoreEvent({
        //   type: actions.GRAPHSET_STATE_CHANGED,
        //   data: 0,
        // });
        if (window.setReportWindowTabBusy)
          window.setReportWindowTabBusy(schema, false);
        return;
      }
    }).catch (() => {
      console.log("failed")
      if (window.setReportWindowTabBusy)
          window.setReportWindowTabBusy(schema, false);
      store.dispatch({
        type: "ADD_INTOAST",
        data: {
          name: "Data Fetching Failed",
          content: "Data fetching failed",
          createAt: Date.now(),
          autoClose: 8000,
          showError:true
        },
      });
    })
    // mixpanel.track("User Looks For Trip Report", {
    //   Platform: "Web",
    //   Application: "Web",
    //   Screen: "Report",
    // });
  };
  
  const flipRangeWrap = flipRange.call(this, (report) => {
    report.schema.toolbar[4].onClick = report.odometerRange
      ? onFetchOdo(getHistory)
      : getHistory;
  });
  
  const isHeadShowable = (item, props, head) => {
    if(head.key === "source" && window.userInfo.SELF.enable_source !== true) {
      return false
    }
    return true
  }
  const download = (schema, data, store) => {
    // mixpanel.track("User Downloads Trip Report", {
    //   Platform: "Web",
    //   Application: "Web",
    //   Screen: "Report",
    // });
    let strictColumns =
      store.groupTree.children.filter((g) => (g.path || "").indexOf("1259") > -1)
        .length > 0; // kushalsslp
        let filterdData =  schema.content[0].ref.state.body
    if (filterdData) {
      
      let finalData = _.map(filterdData, (r) => {
        r = Object.assign({}, r);
        r.starttime = moment(r.starttime).format(dateFormat);
        r.endtime = moment(r.endtime).format(dateFormat);
        if (strictColumns) {
          r.startloc = stripLoc(r.startloc);
          r.endloc = stripLoc(r.endloc);
        }  
        return r;
      });
      if (strictColumns) {
        finalData = _.map(finalData, (r) => {
          if (window.userInfo.SELF.pbl_report === "SHOW") {
            let head = schema.content[0].head;
            let newHead = [];
            for (let idx in head) {
              if (
                head[idx].key !== "cpk" &&
                head[idx].key !== "mileage" &&
                head[idx].key !== "idlingtime" &&
                head[idx].key !== "acidlingtime"
              ) {
                newHead.push(head[idx].key);
              }
            }
            return _.pick(r, newHead);
          }
          let headings = schema.content[0].head
            .filter((c) => (c.isShowable ? c.isShowable() : true))
            .map((c) => c.key);
          return _.pick(r, headings);
        });
      }
      // let removeHead = ["mileage", "idlingtime", "acidlingtime", "tripscore", "startdte", "enddte","cpk", "fuelprice", "uid", "starttime__processed__", "endtime__processed__" ]
      // finalData.map((item) => {
      //   for(let idx in removeHead){
      //     for(let ldx in item){
      //       if(ldx === removeHead[idx]) delete item[ldx]
      //     }
      //   }
      // })
      let heads = schema.content[0].head
      let removeHeads = []
      let evOnly = window.userInfo.SELF.EV_ONLY;
      let evConfig =window.userInfo.SELF.enable_EV_trip_report
      let disableHeadEV = ["cpk","mileage","fuelprice","idlingtime","acidlingtime"]
      let removeHead = [ "idlingtime", "acidlingtime", "tripscore", "startdte", "enddte",
       "uid", "starttime__processed__", "endtime__processed__", "fuelused","ophours","consumption","cph"]
       if(evOnly ==="DISABLE" || evConfig){
        removeHeads = removeHead.concat(disableHeadEV)
       }else {
        removeHeads = removeHead
        removeHeads.push("status")
       }
       if(window.userInfo.SELF.enable_source !== true) {
        removeHeads.push('source')
      }
       heads = heads.filter((head) => {
        if(!removeHeads.includes(head.key)) {
          return head
        }
      }) 
        schema.newData = []
        for(let idx in finalData){
          let tempdata = {}
          for(let rdx in heads){
            if(heads[rdx].key in finalData[idx]) {
              let key = heads[rdx].key
              let name = heads[rdx].name
              tempdata[name] = finalData[idx][key]
            }
          }
          schema.newData.push(tempdata)
        }
      setTimeout(() => {JSONToCSVConvertor(schema.newData, "MileageReport", false)},500)
    }
  };
  
  const schema = {
    key: "mileage_report",
    name: "Mileage Report",
    showPage: false,
    count: null,
    splitCount:null,
    newData: [],
    toolbar: [
      {
        key: "vehicle",
        type: schemaTypes.MULTI_SELECT,
        storeData: (state) => {
          return {
            data: (() => {
              let newMap = {};
              for (let idx in state.vehicleMap) {
                if (idx.indexOf("user") === -1) {
                  newMap[idx] = state.vehicleMap[idx];
                }
              }
              return newMap;
            })(),
            name: "vehicleno",
            id: "vehicleid",
          };
        },
        maxCount : 6000,
        onItemChange: changeVehicle.bind(this),
        defaultValue: () => {
          return {
            data: window.selectedVehicles.map((i) => {
              return i.id;
            }),
            updatedAt: window.selectedVehiclesUpdatedAt,
          };
        },
      },
      {
        key: "switch",
        type: schemaTypes.BUTTON,
        iconType: "class",
        icon: "fa fa-exchange",
        onClick: flipRangeWrap,
        tooltip: "Switch between date range and odometer",
        isShowable: canShowRangeSwitch,
      },
      {
        key: "starttime",
        type: schemaTypes.DATE_PICKER,
        setIfNull: true,
        placeholder: "Start Date",
        model: Date.now() - 1000 * 60 * 60 * 24,
        hideTime: false,
        schemaKey: "mileage_report"
      },
      {
        key: "endtime",
        type: schemaTypes.DATE_PICKER,
        setIfNull: true,
        placeholder: "End Date",
        model: Date.now() - 1000 * 60,
        hideTime: false,
      },
      {
        key: "status",
        type: schemaTypes.MULTI_SELECT,
        placeholder: "Filter By Status",
        onItemChange: () => {
          setTimeout(() => filterAndSetData1(), 100);
        },
      },
      {
        key: "get_history",
        type: schemaTypes.BUTTON,
        name: "Get Mileage Report",
        onClick: getHistory,
      },
      {
        key: "download",
        type: schemaTypes.BUTTON,
        iconType: "class",
        icon: "fa fa-download",
        onClick: download,
        tooltip: "Download Page"
      },
    ],
    content: [
      {
        key: "dataTable",
        type: schemaTypes.IN_TABLE,
        position: {
          width: 12,
          height: 12,
          left: 0,
          top: 0,
        },
        head: [
          { key: "vehicleno", name: "", name: "Vehicle No" },
          { key: "model", name: "Model" },
          { key: "status", name: "Status" },
          {key:'source', name: "Source",isShowable:isHeadShowable},
          {
            key: "starttime",
            name: "Start Time",
            type: "DATE",
            format: dateFormat,
            width: 1.5,
          },
          {
            key: "endtime",
            name: "End Time",
            type: "DATE",
            format: dateFormat,
            width: 1.5,
          },
          // {key:'duration', name:'Duration (min)'},
          {key:'tDuration', name:'Duration'},
          { key: "distance", name: "Distance (km)" },
          { key: "startfl", name: "Start SOC" },
          { key: "endfl", name: "End SOC" },
          { key: "startdte", name: "Start DTE" },
          { key: "enddte", name: "End DTE" },
          // { key: "fuelused", name: "Fuelused (ltr)",isShowable: (item) => !isEvGroup(item) },
          // { key: "fuelused", name: " SOC Consumed % ", isShowable: (item) => isEvGroup(item) },
          { key: "mileage1", name: "Mileage " },
          // { key: "cpk", name: "CPK (₹)" },
          // { key: "fuelprice", name: "Fuel Price (₹)" },
          { key: "avgspeed", name: "Avg Speed (kmph)" },
         
          // {key:'idlingtime', name:'Idling Time (min)'},
          // {key:'acidlingtime', name:'AC Idling (min)'},
          // { key: "startodo", name: "Start Odo (km)" },
          // { key: "endodo", name: "End Odo (km)" },
          // {key:'tripscore', name:'Trip Score'},
          { key: "ophours", name: "Time of operation in hours" },
          { key: "consumption", name: "Avg consumption (ltrs/hour)" },
          { key: "cph", name: "CPH" },
          {
            key: "startloc",
            name: "Start Location",
            width: 2,
            onClick: (d, item) => {
              window.showInGoogleMaps(item.StartLatLng[0], item.StartLatLng[1]);
            },
          },
          {
            key: "endloc",
            name: "End Location",
            width: 2,
            onClick: (d, item) => {
              window.showInGoogleMaps(item.EndLatLng[0], item.EndLatLng[1]);
            },
          },
        ],
      },
    ],
  };
  export default schema;